<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1 || pageLoading2 || pageLoading3" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card">
	<div class="card-header bg-theme">
		<h4 class="card-title mb-0 p-0 fw-bold">
			Reference No.: {{details?.ref_no}}
		</h4>
	</div>
	<div class="card-body">
		<div class="row g-1">
			<div class="col-12">
				<label class="me-5 small">
					<strong>Company:</strong>
					{{details?.company_name}}
				</label>
				<label class="me-5 small">
					<strong>Profile:</strong>
					{{details?.profile_name}}
				</label>
				<label class="me-5 small">
					<strong>Date:</strong>
					{{formatDate(details?.DOE)}}
				</label>
				<label class="me-5 small">
					<strong>Assessor:</strong>
					{{details?.trainer}}
				</label>
			</div>
			<!-- <div class="col-3">
				<ng-select appendTo="body" [items]="trainerList" bindLabel="full_name" bindValue="apptid"
					[clearable]="true" [multiple]="false" [(ngModel)]="filters.trainer" placeholder="Trainer"
					[appearance]="'outline'" (change)="trainerChanged()">
				</ng-select>
			</div> -->
		</div>
	</div>
</div>
<div class="row g-1">
	@for (appt of apptListFiltered; track appt; let i = $index; let apptCount = $count) {
	<!-- @if(appt[displayFlag]){ -->
	<div [ngClass]="apptListFiltered.length>4?'col':'col'">
		<!-- <div [ngClass]="getDisplayApptCount()>4?'col':'col'"> -->
		<div class="card">
			<div class="card-header" [ngClass]="getBgClass(i)">
				<h5 class="card-title mb-0 p-0 fw-bold">
					<app-gender-icon [gender]="appt.gender"></app-gender-icon>
					{{appt.name}}
				</h5>
			</div>
			<div class="card-body px-1 pt-1 pb-2">
				<div class="row g-1 mb-2">
					<div class="col d-flex">
						<div class="input-group input-group-sm">
							<label class="input-group-text">Notes</label>
							<input class="form-control" [(ngModel)]="appt.notes" />
							<button class="btn btn-outline-success" type="button" (click)="saveSingleNotes(appt)">
								@if(saveNotesLoader == appt.id){
								<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
								}@else {
								<fa-icon [icon]="['fas', 'save']"></fa-icon>
								}
							</button>
						</div>
					</div>
				</div>
				<mat-accordion [hideToggle]="false">
					@for (item of appt.categoryWiseQues; track item; let j = $index; let catCount = $count) {
					<mat-expansion-panel [(expanded)]="item.isExpanded"
						(expandedChange)="accordionToggled(j,item.isExpanded)">
						<mat-expansion-panel-header class="bg-secondary" [collapsedHeight]="'35px'"
							[expandedHeight]="'40px'">
							<mat-panel-title>
								<strong class="text-light small">
									{{item.category}}
								</strong>
							</mat-panel-title>
						</mat-expansion-panel-header>
						@if(item.que_list.length){
						<table class="table table-bordered queans-table my-1">
							<tbody>
								@for (que of item.que_list; track que; let k = $index; let queCount = $count) {
								<tr>
									<td>
										<div class="row g-0">
											<div class="col-12">
												<p class="mb-0 small">
													<strong>{{k + 1}}.</strong>
													{{que.question_name}}
												</p>
											</div>
											<div class="col-12">
												<mat-radio-group [(ngModel)]="que.ans"
													(change)="saveSingle(appt.encrypt_id,que.question_id,que.ans)">
													@if(que.Value.length){
													@for (option of que.Value; track option) {
													<mat-radio-button [value]="option.value" [color]="'primary'"
														class="in-ans">
														{{option.ans | titlecase}}
													</mat-radio-button>
													}
													}
												</mat-radio-group>
											</div>
										</div>
									</td>
								</tr>
								}
							</tbody>
						</table>
						}@else {
						<p class="mb-0 text-center fw-bold">No questions</p>
						}
					</mat-expansion-panel>
					}
				</mat-accordion>
			</div>
		</div>
	</div>
	<!-- } -->
	}
</div>
<div class="row g-1">
	<div class="col">
		<div class="card">
			<div class="card-body px-1 pt-1 pb-2">
				<button type="button" class="btn btn-sm btn-outline-success" (click)="saveAllAnswers()">
					@if(showLoader){
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas','save']"></fa-icon>
					}
					Save
				</button>
				<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/edit-appointment',refNo]">
					Cancel
				</a>
			</div>
		</div>
	</div>
</div>